import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Subject } from 'rxjs';
import { Globals } from "../../globals";
import { StockServices } from "../stock/services";
import { OrdersCoServices } from '../orders/services';
import * as moment from 'moment';
import { NativeStorage } from '@ionic-native/native-storage';
import { AnalyticsServices } from '../services/analyticsServices';
import { DishServices } from '../dish/services';
import { ProductsServices } from '../products/services';
import { IngredientsServices } from '../ingredients/services';
import { ConfigurationServices } from '../configuration/services';
import { AlertController } from 'ionic-angular';

interface Room {
    UID: string;
    name: string;
    order: number;
    map: boolean;
}

interface Table {
    UID: string;
    name: string;
    ticket: Ticket;
    cash_static: any;
    cash_uid: any;
    type: string;
    discount_type: string;
    discount_value: number;
    room: any;
    persons: number;
    order: number;
    customer: any;
    //map_style: string;
    //map_transform:String; 
}



type Ticket = {
    UID: string;
    number: any;
    cash_uid: any;
    date: Date;
    list: any;
    amount: number;
    payment: boolean;
    payment_type: string;
    waiter: string;
    waiter_uid: string;
    created_at: any;
    tip: number;
}


interface Menu {
    UID: string;
}

interface Dish {
    UID: string;
    tags: any;
    name_es: string;
}

interface Product {
    UID: string;
    tags: any;
}

interface Cash {
    UID: string;
    name: string;
    number: any;
    _active: boolean;
}

@Injectable()
export class TPVServices {
    //TMP
    public menu_select_room = 'room';
    public section_select = 'menu';
    public selected_type: any;
    public firestore: any;
    public ticket_uid: any;
    public ticket_amount: any;
    public selectedPersonId: any;
    public selected_tag: any;
    public customer: any;




    //button unidades
    public number_units: any;
    public _name: any;
    public _price: any;
    public _delete: any;
    public _count: any;
    public _type: any;
    public _uid: any;
    public units: any;
    public change_units: boolean = false;

    public is_in_order = false;

    constructor(public afs: AngularFirestore,
        public globals: Globals,
        public stockServices: StockServices,
        public ordersCoServices: OrdersCoServices,
        private nativeStorage: NativeStorage,
        public analyticsServices: AnalyticsServices,
        public dishServices: DishServices,
        public productsServices: ProductsServices,
        public ingredientsServices: IngredientsServices,
        public configurationServices: ConfigurationServices,
        public alertCtrl: AlertController) {
        this.firestore = firebase.firestore();
    }

    //Rooms
    roomsCol: AngularFirestoreCollection<Room>;
    rooms: Observable<Room[]>;
    roomsDoc: AngularFirestoreDocument<Room>;
    room: any;
    room_selected_uid: any;
    room_selected_name: any;
    room_selected_map: boolean;
    total_rooms: number;
    rooms_array: any = [];
    rooms_panels: any[] = [];

    getRooms(UID_RESTAURANT) {
        this.roomsCol = this.afs.collection('rooms', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT));
        this.rooms = this.roomsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Room;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
        //Recuperamos el total de comedores
        this.rooms.subscribe(doc => {
            this.total_rooms = doc.length;
        });
        //Guardamos los comedores en un array
        this.roomsCol.snapshotChanges().subscribe(value => {
            this.rooms_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Room;
                data.UID = a.payload.doc.id;
                this.rooms_array.push(data);
                let room_panel_index = this.rooms_panels.findIndex(x => x.UID === data.UID);
                //Comprovamos si el comedor existe en array, para actualizar solo los campos necesarios, si no, lo añadimos
                if (room_panel_index != -1) {
                    this.rooms_panels[room_panel_index] = {
                        name: data.name,
                        content: this.tables_array.filter(x => x.uid_room === data.UID),
                        UID: data.UID,
                        open: this.rooms_panels[room_panel_index].open,
                        persons: this.tables_array.filter(x => x.uid_room === data.UID).reduce((sum, table) => sum + (table.persons || 0), 0),
                        order: data.order || 0,
                        map: data.map || false,
                        active: this.globals.checkLimitsByLicense('config', 'rooms') != -1 && index >= this.globals.checkLimitsByLicense('config', 'rooms') ? false : true
                    };
                } else {
                    this.rooms_panels.push({
                        name: data.name,
                        content: this.tables_array.filter(x => x.uid_room === data.UID),
                        UID: data.UID,
                        open: true,
                        persons: this.tables_array.filter(x => x.uid_room === data.UID).reduce((sum, table) => sum + (table.persons || 0), 0),
                        order: data.order || 0,
                        map: data.map || false,
                        active: this.globals.checkLimitsByLicense('config', 'rooms') != -1 && index >= this.globals.checkLimitsByLicense('config', 'rooms') ? false : true
                    });
                }
                this.rooms_panels.sort((one, two) => (one.order < two.order ? -1 : 1));
                return data;
            });
        });
    }

    //Tables
    tablesCol: AngularFirestoreCollection<Table>;
    tables: Observable<Table[]>;
    tables_takeaway: Observable<Table[]>;
    tables_array: any = [];
    public table_tmp: Table;
    tablesDoc: AngularFirestoreDocument<Table>;
    table: any;
    selected_table_tpv: any;
    selected_table_tpv_index: any;
    table_bar_index: any;
    tables_array_take_away: any;
    tables_room_array: any;


    getTables(UID_RESTAURANT) {
        this.tablesCol = this.afs.collection('tables', ref => ref
            .where('UID_RESTAURANT', '==', UID_RESTAURANT)
            //.where('type','<','takeaway').orderBy('type', 'asc').orderBy('name', 'asc'));
            .where('type', '<', 'takeaway').orderBy('type', 'asc').orderBy('order', 'asc'));

        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });

        this.tablesCol.snapshotChanges().subscribe(value => {
            this.tables_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_array.push(data);
                //Anadimos el index de la tabla bar para poder utilizarlo.
                if (data.type == 'bar') {
                    this.table_bar_index = index;
                }
                return data;
            });
            //miramos si table seleccionada esta pagada
            this.checkIfTablePaid()
            this.rooms_panels.forEach(doc => {
                // Filtra las mesas (tables) que pertenecen a la habitación (room) actual
                doc.content = this.tables_array.filter(x => x.uid_room === doc.UID);
                // Suma el total de 'persons' de todas las mesas filtradas
                doc.persons = doc.content.reduce((sum, table) => sum + (table.persons || 0), 0);
            });
        });
    }

    getTablesRoom(UID_RESTAURANT, room_uid) {
        this.tablesCol = this.afs.collection('tables', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('uid_room', '==', room_uid)
            .orderBy('order', 'asc'));
        this.tables = this.tablesCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                return data;
            });
        });
        //Guardamos los comedores en un array
        this.tablesCol.snapshotChanges().subscribe(value => {
            this.tables_room_array = [];
            value.map((a, index) => {
                const data = a.payload.doc.data() as Table;
                data.UID = a.payload.doc.id;
                this.tables_room_array.push(data);
                return data;
            });
        });
    }

    tables_tmp: any;
    async getTablesRoomAsync(UID_RESTAURANT, room_uid) {
        const tRef = this.firestore.collection('tables');
        var tables = [];

        await tRef.where('UID_RESTAURANT', '==', UID_RESTAURANT)
            .where('uid_room', '==', room_uid)
            .get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    var table = doc.data();
                    table.UID = doc.id;
                    tables.push(table);
                });
            });
        return tables;
    }

    //Restamoss stock
    /*async deductStock() {
        for (let key in this.table_tmp.ticket.list) {
            var _type = this.table_tmp.ticket.list[key].type;
            var _uid = this.table_tmp.ticket.list[key].uid_element;

            if (_type == 'dish') {
                var dish = await this.dishServices.getDish(_uid);
                for (let key in dish.foodcost) {
                    this.updateDeductedStock(_type, dish.foodcost[key]);
                }
            } else if (_type == 'product') {
                var product = await this.productsServices.getProduct(_uid);
                product.uid = _uid;
                this.updateDeductedStock(_type, product);

            }
        }
    }

    async updateDeductedStock(type, proding) {
        if (type == 'dish') {
            var ingredient = await this.ingredientsServices.getIngredient(proding.uid);

            var _stock = this.calculateMeasurements(ingredient.measurement, ingredient.stock, proding.quantity_gross);
            this.ingredientsServices.afs.collection('ingredients').doc(proding.uid).update({
                'stock': _stock,
            });
        } else if (type == 'product') {
            var _stock = this.calculateMeasurements(proding.measurement, proding.stock, proding.quantity_gross);
            this.ingredientsServices.afs.collection('products').doc(proding.uid).update({
                'stock': _stock,
            });
        }
    }

    calculateMeasurements(measurement, stock, minus_stock) {
        if (measurement === 'kg' || measurement === 'l') {
            //kg l
            var stock_grams_ml = parseFloat(stock) * 1000;

            var total = stock_grams_ml - parseFloat(minus_stock);



            return total / 1000;
        }else{
            return parseInt(stock) - 1;
        }
    }*/

    //Limpiamos array para subir a firebase
    cleanTicketArray() {
        for (let key in this.table_tmp.ticket.list) {
            delete this.table_tmp.ticket.list[key].variation_array;
            delete this.table_tmp.ticket.list[key].variation_add;
        }
    }

    //Creamos temporal de variacions del plato
    variations_tmp = Array();


    //Inserta un elemento en una mesa
    public k_screen: any;
    insertTable(_name, _price, _delete, _count, _type, _uid, _element) {
        this._name = _name;
        this._price = _price;
        this._delete = _delete;
        this._count = _count;
        this._type = _type;
        this._uid = _uid;
        //
        this.k_screen = _name;
        this.keyboard_screen = this.k_screen;
        //check tags
        if (_element.tags == undefined) {
            _element.tags = [];
        }
        //check type unit
        if (_element.type_unit == undefined) {
            _element.type_unit = "ud";
        }
        //check tax
        if (_element.tax == undefined) {
            _element.tax = parseFloat(this.globals.user_tax);
        }
        //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        this.table_tmp = this.tables_array[this.selected_table_tpv_index];
        //Eliminamos el camp variation array para poder hacer el update
        this.cleanTicketArray();

        var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
        }
        //Creamos objeto del nuevo plato
        this.table_tmp.ticket.list[Number(last_key) + 1] = {
            name: _name,
            price: _price,
            delete: _delete,
            count: _count,
            tax: _element.tax,
            type: _type,
            uid_element: _uid,
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
            tags: _element.tags,
            type_unit: _element.type_unit
        };
        if (_element.type_unit === 'scale') {
            this.table_tmp.ticket.list[Number(last_key) + 1].units = 1;
        }
        //created_at
        if (this.table_tmp.ticket.created_at == undefined) {
            this.table_tmp.ticket.created_at = new Date();
        }

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'close'
        }).then(doc => {
            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'add',
                'value': 1,
                'source': 'tpv',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        });
        //insert _data analytics WAITER
        var analytics_element = [];
        analytics_element.push(_name)
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': analytics_element,
            'date': new Date(),
            'type': "waiter",
            'type_type': "ADD",
        };
        this.analyticsServices.sendWaiter(waiter);
    }

    insertTableDiscount(_name, _price, _delete, _count, _type, _uid, discount_type, discount_value, rest_tax) {
        this._name = _name;
        this._price = _price;
        this._delete = _delete;
        this._count = _count;
        this._type = _type;
        this._uid = _uid;
        var _rest_tax = rest_tax;
        //

        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Eliminamos el camp variation array para poder hacer el update
        this.cleanTicketArray();

        var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
        if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
        }
        //check tax
        if (_rest_tax == undefined) {
            _rest_tax = parseFloat(this.globals.user_tax);
        }
        //
        this.table_tmp.ticket.list[Number(last_key) + 1] = {//Creamos objeto del nuevo plato
            name: _name,
            price: _price,
            delete: _delete,
            count: _count,
            type: _type,
            uid_element: _uid,
            waiter: this.globals.waiter,
            waiter_uid: this.globals.waiter_uid,
            units: 1,
            tax: _rest_tax,
            tags: []
        };

        //this.table_tmp.discount_type = discount_type;
        //this.table_tmp.discount_value = discount_value;
        //created_at
        if (this.table_tmp.ticket.created_at == undefined) {
            this.table_tmp.ticket.created_at = new Date();
        }

        if (this.table_tmp.discount_value) {
            this.table_tmp.discount_value += discount_value;
        } else {
            this.table_tmp.discount_value = discount_value;
        }


        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            discount_type: discount_type,
            discount_value: this.table_tmp.discount_value
        }).then(doc => {
            var extra_activity: any = {};
            //data set waiter activity
            if (discount_type == 'invite') {
                extra_activity =
                {
                    'type': 'invite',
                    'value': 1,
                    'source': 'tpv',

                };
            } else {
                extra_activity =
                {
                    'type': 'linediscount',
                    'value': discount_value,
                    'source': 'tpv',

                };
            }

            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        });

    }

    //Inserta un elemento con variaciones en una mesa
    insertTableWithVariation(_name, _price, _delete, _count, _type, _uid, units, _element) {
        for (var i = 0; i < units; i++) {
            // Insert
            this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

            //Eliminamos el camp variation array para poder hacer el update
            this.cleanTicketArray();

            var last_key = Object.keys(this.table_tmp.ticket.list)[Object.keys(this.table_tmp.ticket.list).length - 1]; //get the last key in the object
            if (last_key == undefined) {
                last_key = '-1';//Iniciamos a 0 si esta undefined
            }
            //created_at
            if (this.table_tmp.ticket.created_at == undefined) {
                this.table_tmp.ticket.created_at = new Date();
            }
            //check tags
            if (_element.tags == undefined) {
                _element.tags = [];
            }
            //check type unit
            if (_element.type_unit == undefined) {
                _element.type_unit = "ud";
            }
            //check tax
            if (_element.tax == undefined) {
                _element.tax = parseFloat(this.globals.user_tax);
            }
            //Creamos objeto del nuevo plato
            this.table_tmp.ticket.list[Number(last_key) + 1] = {
                name: _name,
                price: _price,
                delete: _delete,
                count: _count,
                tax: _element.tax,
                type: _type,
                uid_element: _uid,
                waiter: this.globals.waiter,
                waiter_uid: this.globals.waiter_uid,
                variation: this.variations_tmp,
                tags: _element.tags,
                type_unit: _element.type_unit
            };
            if (_element.type_unit === 'scale') {
                this.table_tmp.ticket.list[Number(last_key) + 1].units = 1;
            }
            //Actualizamos la tabla de la base de datos
            this.afs.collection('tables').doc(this.table_tmp.UID).update({
                ticket: {
                    amount: this.table_tmp.ticket.amount,
                    payment: this.table_tmp.ticket.payment,
                    payment_type: this.table_tmp.ticket.payment_type,
                    date: this.table_tmp.ticket.date,
                    number: this.table_tmp.ticket.number,
                    waiter: this.table_tmp.ticket.waiter,
                    waiter_uid: this.table_tmp.ticket.waiter_uid,
                    list: this.table_tmp.ticket.list,
                    created_at: this.table_tmp.ticket.created_at,
                    updated_at: new Date(),
                    tip: this.checkTip(this.table_tmp.ticket.tip),
                },
                state: 'close'
            }).then(doc => {
                //data set waiter activity
                var extra_activity: any =
                {
                    'type': 'add',
                    'value': 1,
                    'source': 'tpv',

                };
                this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
            });


        }


        this.variations_tmp = [];

    }

    //Elimina un elemento de una mesa
    deleteTableList(valueSearch) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Eliminamos el camp variation array para poder hacer el update
        for (let key in this.table_tmp.ticket.list) {
            delete this.table_tmp.ticket.list[key].variation_array;
            if (this.table_tmp.discount_value > 0) {
                delete this.table_tmp.ticket.list[key].state_indv;
            }
        }

        var discount_type = this.table_tmp.discount_type;
        var discount_value = this.table_tmp.discount_value;
        //
        let _elements = [];
        //Eliminamos los elementos segun su valor de la key en el objeto. Borrara todas las unidades
        while (Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch)) {
            _elements.push(valueSearch)

            //descuento
            if (this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))].price < 0) {

                if (this.table_tmp.discount_type == 'linediscount') {
                    discount_value += this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))].price;
                } else if (this.table_tmp.discount_type == 'invite') {
                    discount_value += this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))].price;
                } else {
                    discount_type = '';
                    discount_value = 0;
                }


            }
            delete this.table_tmp.ticket.list[Number(Object.keys(this.table_tmp.ticket.list).find(key => this.table_tmp.ticket.list[key].name === valueSearch))];
        }

        //caso array -> cuando viene de ANDROID
        if (Array.isArray(this.table_tmp.ticket.list)) {
            this.table_tmp.ticket.list = this.table_tmp.ticket.list.filter(item => item !== "empty");
        }

        //insert _data analytics WAITER
        var waiter = {
            'uid': this.globals.restaurant_uid,
            'waiter': this.globals.waiter,
            'elements': _elements,
            'date': new Date(),
            'type': "waiter",
            'type_type': "DELETE",
        };
        this.analyticsServices.sendWaiter(waiter);
        //discount
        if (this.table_tmp.discount_type == undefined) {
            discount_type = '';
            discount_value = 0;
        }

        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: this.table_tmp.ticket.number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            discount_type: discount_type,
            discount_value: discount_value
        }).then(doc => {
            //data set waiter activity
            var extra_activity: any =
            {
                'type': 'cancel',
                'value': 1,
                'source': 'tpv',

            };
            this.globals.dataSet('waiter_activity', this.globals.waiter_uid, '', JSON.stringify(extra_activity), '');
        });

    }

    //Precio total de les elementos del ticket
    totalTicketSelected(index) {
        //total
        var total = 0;
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        total += _taxs.total;
        //tip
        if (this.tables_array[index].ticket.tip) {
            total += parseFloat(this.tables_array[index].ticket.tip);
        }
        return total;
    }

    //Precio total ticket sin impuestos
    totalTicketSelectedNoTax(index, tax) {
        var _taxs = this.globals.showIvaProducts(this.tables_array[index].ticket.list);
        return _taxs.subtotal;
    }

    //Lista de elementos selecionados en una mesa
    listSelectedTicket(propertyName, inputArray) {
        //Inicializamnos los arrays
        var array_return = Array();
        var array_count = Array();
        var array_count_return = Array();
        var array_nocount = Array();
        var array_nocount_return = Array();
        var array_delete = Array();
        var array_delete_return = Array();


        //Separamos los valores del array conjunto por los array del coun, no count i delete
        inputArray.map(function (item) {
            if (item.count && !item.delete) {
                //count true
                array_count.push(item);
            } else if (!item.count && !item.delete) {
                //count false
                array_nocount.push(item);
            } else if (item.delete) {
                //Delete true
                array_delete.push(item);
            }
        });

        //Count
        array_count.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();

            //Buscamos los elementos por uid_element, si no por name
            var itemPropertyName = item['name'];
            var itemPropertyPrice = item['price'];
            /*if (item['uid_element'] == undefined || item['uid_element'] == '') {
                itemPropertyName = item[propertyName];
            }*/
            if (itemPropertyName in array_count && item.type_unit != 'scale') {
                if (itemPropertyPrice === array_count[itemPropertyName].price) {//miramos si precio es diferentep
                    array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_count[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_count[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_count[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones

                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_count[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }
            } else {
                array_count[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_count[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_count[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones

                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_count[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_count[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_count.forEach(value => {
            if (value.duplicate != true) {
                array_count_return.push(value);
            }
        });

        //No Count
        array_nocount.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            var itemPropertyPrice = item['price'];

            if (itemPropertyName in array_nocount && item.type_unit != 'scale') {
                if (itemPropertyPrice === array_nocount[itemPropertyName].price) {//miramos si precio es diferentep
                    array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_nocount[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_nocount[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones
                        array_nocount[itemPropertyName].variation_array = Array();
                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }

            } else {
                array_nocount[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_nocount[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_nocount[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_nocount[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_nocount[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_nocount[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_nocount.forEach(value => {
            if (value.duplicate != true) {
                array_nocount_return.push(value);
            }
        });

        //Delete
        array_delete.map(function (item) {
            //Duplicate item
            if (item.type_unit != 'scale') {
                item.units = 0;// Iniciamos las unidades
            }
            item.variation_array = Array();
            var itemPropertyName = item[propertyName];
            var itemPropertyPrice = item['price'];

            if (itemPropertyName in array_delete) {
                if (itemPropertyPrice === array_delete[itemPropertyName].price && item.type_unit != 'scale') {//miramos si precio es diferentep
                    array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    if (item.variation) {//Comprovamos si tiene variaciones
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                        }
                    }
                    item.duplicate = true;//Marcamos item como duplicado
                } else {//caso precio diferente volvemos a inicializar sus datos
                    array_delete[itemPropertyName] = item;
                    if (item.type_unit != 'scale') {
                        array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                    }
                    array_delete[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                    if (item.variation) {//Comprovamos si tiene variaciones
                        array_delete[itemPropertyName].variation_array = Array();
                        //Add variation
                        for (let key in item.variation) {
                            let value = item.variation[key];
                            array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                            array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                        }

                    }
                }
            } else {
                array_delete[itemPropertyName] = item;
                if (item.type_unit != 'scale') {
                    array_delete[itemPropertyName].units++; //Sumamos las unidades del mismo elemento
                }
                array_delete[itemPropertyName].variation_add = 0;//inicializamos la variable para poder mostrar el precio. Sino falla al sumar con un numero que no es 0.

                if (item.variation) {//Comprovamos si tiene variaciones
                    array_delete[itemPropertyName].variation_array = Array();
                    //Add variation
                    for (let key in item.variation) {
                        let value = item.variation[key];
                        array_delete[itemPropertyName].variation_array.push(Array(value.state + ' ' + value.name, value.price));//Anadimos los valores de las variaciones
                        array_delete[itemPropertyName].variation_add += parseFloat(value.price);
                    }

                }
                delete item.duplicate;
            }
        });
        array_delete.forEach(value => {
            if (value.duplicate != true) {
                array_delete_return.push(value);
            }
        });

        array_return.push(array_count_return);
        array_return.push(array_nocount_return);
        array_return.push(array_delete_return);

        return array_return;//Devolvemos array con las cantidades agrupadas
    }

    //Actualiza el numoer de comensales
    tableUpdatePersons(persons) {
        var number_persons = 0;
        if (persons) {
            number_persons = persons;
        } else {
            number_persons = this.tables_array[this.selected_table_tpv_index].persons;
        }
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            persons: number_persons,
        });
    }

    //Actualiza el customer
    tableUpdateCustomer(customer) {
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            customer: customer,
        });
    }

    //Elimina todos los elementos del ticket
    cancelTicket(type) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: this.table_tmp.ticket.date,
                number: '',
                waiter: '',
                waiter_uid: '',
                list: {},
                created_at: new Date(),
                updated_at: new Date(),
                tip: 0
            },
            state: 'open',
            discount_type: '',
            discount_value: 0,
            customer: {}
        });
        //
        this.deleteOrders(this.table_tmp.UID);

        if (type === 'cancel') {//solo en caso de cancelar
            //insert _data analytics WAITER
            let _element = [];
            _element.push("TICKET")
            var waiter = {
                'uid': this.globals.restaurant_uid,
                'waiter': this.globals.waiter,
                'elements': _element,
                'date': new Date(),
                'type': "waiter",
                'type_type': "DELETE",
            };
            this.analyticsServices.sendWaiter(waiter);
            //insert _data analytics cancel_tickets
            if (this.table_tmp.ticket.number) {
                var cancel_table_ticket = {
                    'uid': this.globals.restaurant_uid,
                    'number': this.table_tmp.ticket.number,//numero ticket cancelado
                    'cash': this.table_tmp.cash_static,//caja que dio el numero ticket
                    'cash_uid': this.table_tmp.cash_uid,//uid de la caja
                    'type': this.table_tmp.type,//table o tk (sitio donde se ejecuto)
                    'amount': this.totalTicketSelected(this.selected_table_tpv_index),
                    'name': this.table_tmp.name,// nombre mesa/tk
                    'waiter': this.globals.waiter,//camrero que ejecuto accion
                    'app_section': 'APP2',//app donde se ejecuto
                    'date': new Date()
                }
                this.analyticsServices.cancelTableTicket(cancel_table_ticket);
            }
        }
    }

    deleteOrders(table_uid) {
        var jobskill_query = this.firestore.collection('orders')
            .where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
            .where('table_uid', '==', table_uid);
        jobskill_query.get().then(function (querySnapshot) {
            querySnapshot.forEach(async function (doc) {
                await doc.ref.delete();
            });
        });
    }

    public total_ticket_indv_print = 0;
    public subtotal_ticket_indv_print = 0;
    public tip_ticket_indv_print = 0;

    totalTicketIndv(elements) {//Total del ticket individual
        var total = 0;
        for (let key in elements) {
            let value = elements[key];
            if (value.state_indv == 'selected') {
                total += Number(value.price);
                for (let key_var in value.variation) {
                    total += Number(value.variation[key_var].price);
                }
            }
        }
        this.total_ticket_indv_print = total;
        return total;
    }

    totalTicketIndvNoTax(elements, tax) {//Total del ticket individual no tax
        var total = this.totalTicketIndv(elements);
        //var sub =  total - (total * tax / 100);
        var sub = Number(total) / ((Number(tax) + 100) / 100);
        this.subtotal_ticket_indv_print = sub;
        return Number(sub);
    }

    totalTicketIndvElementPrice(element) {//Total de un elemento individual del ticket indv
        var total = 0;
        total += Number(element.price);
        for (let key_var in element.variation) {
            total += Number(element.variation[key_var].price);
        }
        return total;
    }

    cleanTicketIndvSelectedArray() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        for (let key in this.table_tmp.ticket.list) {
            if (this.table_tmp.ticket.list[key].state_indv === 'selected') {
                this.table_tmp.ticket.list[key].state_indv = 'pay';
                this.updateSelectedToPay(this.table_tmp.ticket.number);
            }
        }
    }


    cleanTicketIndvSelectedArrayInvite() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        for (let key in this.table_tmp.ticket.list) {
            if (this.table_tmp.ticket.list[key].state_indv === 'selected') {
                this.updateTableNumberInvite(this.table_tmp.ticket.number);
            }
        }
    }

    async updateSelectedToPay(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        await this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: new Date(),
                number: '',
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'ticket'
        });

    }



    async updateTableNumber(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        await this.cleanTicketArray();

        var _date = new Date();
        this.tables_array[this.selected_table_tpv_index].ticket.date = _date;
        this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: _date,
                number: number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: _date,
                tip: this.checkTip(this.table_tmp.ticket.tip),
            },
            state: 'ticket'
        })

    }

    async updateTableNumberInvite(number) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada

        //Actualizamos la tabla de la base de datos
        await this.afs.collection('tables').doc(this.table_tmp.UID).update({
            ticket: {
                amount: this.table_tmp.ticket.amount,
                payment: this.table_tmp.ticket.payment,
                payment_type: this.table_tmp.ticket.payment_type,
                date: new Date(),
                number: number,
                waiter: this.table_tmp.ticket.waiter,
                waiter_uid: this.table_tmp.ticket.waiter_uid,
                list: this.table_tmp.ticket.list,
                created_at: this.table_tmp.ticket.created_at,
                updated_at: new Date(),
                tip: this.table_tmp.ticket.tip || 0
            },
            state: 'close'
        });

    }

    tableUpdateCash(cash) {//funcion que actuliza la caja del ticket de la table
        //Actualizamos la tabla de la base de datos
        this.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
            cash_static: cash.name,
            cash_uid: cash.UID,
        });
    }


    async cashTicketPay(payment_type, type) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //dataset
        for (let element of this.globals.objectToArray(this.table_tmp.ticket.list)) {
            if (element.type == 'menu' || element.type == 'combo') {
                this.globals.dataSet('sales_menu', element.name, '', element.price, '');
            } else if (element.type == 'dish') {
                this.globals.dataSet('sales_dish', element.name, '', element.price, '');
            } else if (element.type == 'product') {
                this.globals.dataSet('sales_product', element.name, '', element.price, '');
            }
        }
        //Borramos comandas de comandero
        this.ordersCoServices.deleteOrdersWhenPay(this.globals.restaurant_uid, this.table_tmp.UID);
        //Eliminamos el camp variation array para poder hacer el update
        await this.cleanTicketArray();

        //get ticket number
        if (this.globals.connection) {
            await this.getTicketNumber(this.globals.restaurant_uid, this.table_tmp.cash_uid);
        } else {
            await this.getTicketNumberOffline();
        }

        this.table_tmp = this.tables_array[this.selected_table_tpv_index];
        //comprovar discount
        if (this.table_tmp.discount_type == undefined || this.table_tmp.discount_value == undefined) {
            this.table_tmp.discount_type = '';
            this.table_tmp.discount_value = 0;
        }
        //type bar
        if (type == 'bar') {
            this.table_tmp.room = '';
        }
        var _amount = this.totalTicketSelected(this.selected_table_tpv_index);

        var _customer_uid;

        //Si no hay el campo customer.UID en la mesa
        if (this.table_tmp.customer == undefined) {
            this.table_tmp.customer = {};
            _customer_uid = '';
            this.table_tmp.customer = '';

        } else {
            if (this.table_tmp.customer.UID == undefined) {
                _customer_uid = '';
                this.table_tmp.customer = '';
            } else {
                _customer_uid = this.table_tmp.customer.UID;
            }
        }

        if (this.table_tmp.ticket.tip == undefined) {
            this.table_tmp.ticket.tip = 0;
        }


        //insertar
        await this.cleanTicketArray();
        this.afs.collection('tickets').add({
            UID_RESTAURANT: this.globals.restaurant_uid,
            amount: _amount,
            tax: this.globals.RESTAURANT_TAX,
            cash_static: this.table_tmp.cash_static,
            cash_uid: this.table_tmp.cash_uid,
            date: this.table_tmp.ticket.date,
            list: this.table_tmp.ticket.list,
            number: this.ticket_num_return,
            payment: true,
            payment_type: payment_type,
            waiter: this.table_tmp.ticket.waiter,
            waiter_uid: this.table_tmp.ticket.waiter_uid,
            type: type,
            closed: false,
            table_uid: this.table_tmp.UID,
            pending: false,
            discount_type: this.table_tmp.discount_type,
            discount_value: this.table_tmp.discount_value,
            room: this.table_tmp.room,
            table: this.table_tmp.name,
            tip: this.table_tmp.ticket.tip,
            customer_uid: _customer_uid,
            customer: this.table_tmp.customer,
            persons: this.table_tmp.persons,
        }).then(async value => {
            //Si no hay el campo customer.UID no añadimos la informacion del cliente
            if (this.table_tmp.customer != undefined) {
                if (this.table_tmp.customer.UID != undefined) {
                    this.afs.collection('tickets/' + value.id + '/customer').add({
                        'name': this.table_tmp.customer.name,
                        'uid': this.table_tmp.customer.UID,
                        'email': this.table_tmp.customer.email,
                        'address': this.table_tmp.customer.address,
                        'business_name': this.table_tmp.customer.business_name,
                        'business_number': this.table_tmp.customer.business_number,
                        'note': this.table_tmp.customer.note,
                        'phone': this.table_tmp.customer.phone,
                    });
                }
            }
            //create format data for dataset
            var discount = false;
            if (this.table_tmp.discount_type != '') {
                discount = true;
            } else {
                discount = false;
            }
            var extra: any =
            {
                'ticket_open': moment(new Date(this.table_tmp.ticket.created_at.toDate())).format("YYYY/MM/DD HH:mm:ss").toString(),
                'ticket_close': moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString(),
                'persons': this.table_tmp.persons,
                'room': this.table_tmp.room,
                'waiter': this.table_tmp.ticket.waiter,
                'discount': discount,
                'discount_type': this.table_tmp.discount_type,
                'discount_price': this.table_tmp.discount_value,
            };
            //dataset sales ticket
            this.globals.dataSet('sales_ticket', _amount, '', JSON.stringify(extra), '');
            //SALES_SALES ELEMENT
            let elements = [];
            for (let element of this.globals.objectToArray(this.table_tmp.ticket.list)) {
                //comprobamos que el elemento no esté eliminado
                if (!element.delete) {
                    var _element = {
                        "name": element.name,//nom del producto/plato/menu
                        "uid_element": element.uid_element,//uid el producto/plato/menu
                        "sales": element.price,//precio 
                        "type": element.type,//que tipo de elemento es producto/plato/menu
                        "foodcost": 0,//foodcost
                        "waiter": element.waiter,
                        "half": "",
                    };
                    if (element.name.includes('<b> M.</b>')) {
                        _element.half = 'half'
                    } else if (element.name.includes('<b> P.</b>')) {
                        _element.half = 'tap'
                    }
                    //VARAIACIONES
                    elements.push(_element)
                }
            }
            //
            var sales_elements = {
                "uid": this.globals.restaurant_uid,//uid_restaurant
                "uid_doc": value.id,//uid del ticket
                "date": new Date(),//date
                "list": elements,
                "type": "sales_elements",
            };
            var stock = {
                "elements": elements,
                "uid": this.globals.restaurant_uid,
                "date": new Date(),
                "type": "stock",
                "comment": "",
                "type_type": "TICKET",
                "delivery_uid": null
            };
            //insert _data
            this.analyticsServices.sendSalesElements(sales_elements);
            this.analyticsServices.sendStock(stock);

            //SALES_SALES SALE
            var sales_sales = {
                'uid': this.globals.restaurant_uid,
                'uid_doc': value.id,
                'date': this.table_tmp.ticket.date,
                'sales': _amount,
                'type': "sales_sales",
                'type_type': payment_type,
                'persons': this.table_tmp.persons,
                'zone': this.table_tmp.room,
                'discount_type': this.table_tmp.discount_type,
                'discount': this.table_tmp.discount_value,
                'foodcost': 0,
                'tip': this.table_tmp.ticket.tip,
                'app_section': 'tpv',
                'text': this.table_tmp.ticket.number,
                'waiter': this.table_tmp.ticket.waiter
            }
            this.analyticsServices.sendSalesSales(sales_sales);
        });


    }


    //Tickets
    ticketsCol: AngularFirestoreCollection<Ticket>;
    tickets: Observable<Ticket[]>;
    ticketDoc: AngularFirestoreDocument<Ticket>;
    ticket: any;
    ticket_num_return: any = -1;
    ticket_print = 'normal'; //normal - indv
    ticket_print_ind: any;
    ticket_print_ind_number: any;
    ticket_print_ind_date: any;
    ticket_print_ind_waiter: any;
    ticket_print_ind_room: any;
    ticket_print_ind_table: any;
    ticket_print_ind_customer: any = [];


    //Funcion que busca el ultimo numero del ticket y hace update. Controla los numero por cajas y hace una serie diferente por caja
    async getTicketNumber(UID_RESTAURANT, cash_uid) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        await this.cleanTicketArray();

        var _ticket_num_return = -1;
        //this.ticket_num_return = -1;//Reiniciamos el numero para encontrar el nuevo
        if (!this.table_tmp.ticket.number) {//Comprovamos si el ticket ya tiene un numero para no darle uno de nuevo
            var col = this.firestore.collection('cashs').doc(this.table_tmp.cash_uid);
            await col.get()
                .then(async doc => {
                    var doc = doc.data()
                    _ticket_num_return = Number(doc.number) + 1;
                    this.ticket_num_return = _ticket_num_return;
                    this.tables_array[this.selected_table_tpv_index].ticket.number = _ticket_num_return;
                    this.tables_array[this.selected_table_tpv_index].ticket.date = new Date();
                    this.cashUpdateNumber(this.table_tmp.cash_uid, _ticket_num_return);
                    this.updateTableNumber(_ticket_num_return);

                });
            /*
            this.cashs_array.forEach(value => {
                if (value.UID == cash_uid) {
                    _ticket_num_return = value.number + 1;
                    this.ticket_num_return = _ticket_num_return;
                    this.updateTableNumber(_ticket_num_return);
                    this.cashUpdateNumber(value.UID, _ticket_num_return);
                }
            });*/
        } else {
            //darle el numero que ya tiene
            this.ticket_num_return = this.table_tmp.ticket.number;
            //volver a marcar la mesa en ticket (color amarillo)
            this.updateTableNumber(this.ticket_num_return);
        }

        return true;

    }

    //Menus
    menusCol: AngularFirestoreCollection<Menu>;
    combosCol: AngularFirestoreCollection<Menu>;
    menus: Observable<Menu[]>;
    combos: Observable<Menu[]>;
    menusDoc: AngularFirestoreDocument<Menu>;
    menu: any;
    favourite_menus: Observable<Menu[]>;
    favourite_menus_count: number = 0;

    getMenus(UID_RESTAURANT) {
        this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'menu').orderBy('title_es', 'asc'));
        this.menus = this.menusCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getCombos(UID_RESTAURANT) {
        this.combosCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).where('type', '==', 'combo').orderBy('title_es', 'asc'));
        this.combos = this.combosCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Menu;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectMenu(a).localeCompare(this.globals.nameLangSelectMenu(b)));
        });
    }

    getFavouriteMenus(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.menusCol = this.afs.collection('menus', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy('title_es', 'asc'));
            this.favourite_menus = this.menusCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });
            //
            this.menusCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Menu;
                    data.UID = a.payload.doc.id;
                    this.favourite_menus_count++;
                });
            });
        }
    }


    //Dish
    dishsCol: AngularFirestoreCollection<Dish>;
    dishs: Observable<Dish[]>;
    dishsDoc: AngularFirestoreDocument<Dish>;
    dish: any;
    dish_tags: any = Array();
    favourite_dishs: Observable<Dish[]>;
    favourite_dishs_count: number = 0;

    getDish(UID_RESTAURANT) {
        this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy(this.globals.returnLangTag('dish'), 'asc'));
        this.dishs = this.dishsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.dishsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Dish;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.dish_tags.push(value.toLowerCase());
                    });
                }
            });
            this.dish_tags = this.cleanDuplicates(this.dish_tags);//Clean duplicates dish tags to the array
            this.dish_tags = this.globals.orderNamesByAlphabetical(this.dish_tags);//order alphabetic
        });
    }


    getFavouriteDishes(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.dishsCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('dish'), 'asc'));
            this.favourite_dishs = this.dishsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
            this.dishsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Dish;
                    data.UID = a.payload.doc.id;
                    this.favourite_dishs_count++;
                });
            });
        }
    }


    /*Send tag selected between components*/
    private subject = new Subject<any>();

    sendTagDish(message: string) {
        this.subject.next({ message });
    }

    getTagDish(): Observable<any> {
        return this.subject.asObservable();
    }

    //Products
    productsCol: AngularFirestoreCollection<Product>;
    products: Observable<Product[]>;
    productsDoc: AngularFirestoreDocument<Product>;
    product: any;
    products_tags: any = Array();
    favourite_products: Observable<Product[]>;
    favourite_products_count: number = 0;

    getProducts(UID_RESTAURANT) {
        this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy(this.globals.returnLangTag('product'), 'asc'));
        this.products = this.productsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                return data;
            }).sort((a, b) => this.globals.nameLangSelectProduct(a).localeCompare(this.globals.nameLangSelectProduct(b)));
        });

        //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
        this.productsCol.snapshotChanges().subscribe(value => {
            value.map(a => {
                const data = a.payload.doc.data() as Product;
                data.UID = a.payload.doc.id;
                if (data.tags) {
                    data.tags.forEach(value => {//Insert to array all dish tags
                        this.products_tags.push(value.toLowerCase());
                    });
                }
            });
            this.products_tags = this.cleanDuplicates(this.products_tags);//Clean duplicates dish tags to the array
            this.products_tags = this.globals.orderNamesByAlphabetical(this.products_tags);//order alphabetic
        });
    }

    getFavouriteProducts(UID_RESTAURANT) {
        if (this.globals.checkLimitsByLicense('tpv', 'favourites')) {
            this.productsCol = this.afs.collection('products', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT)
                .where('pos_favourite', '==', true)
                .orderBy(this.globals.returnLangTag('product'), 'asc'));
            this.favourite_products = this.productsCol.snapshotChanges().map(actions => {
                return actions.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    return data;
                });
            });

            //Funcion importante para cuando tienens que trabajr con los datos recuperados de toda una collection
            this.productsCol.snapshotChanges().subscribe(value => {
                value.map(a => {
                    const data = a.payload.doc.data() as Product;
                    data.UID = a.payload.doc.id;
                    this.favourite_products_count++;
                });
            });
        }
    }

    /*Send tag selected between components*/
    private subjectProduct = new Subject<any>();

    sendTagProduct(message: string) {
        this.subjectProduct.next({ message });
    }

    getTagProduct(): Observable<any> {
        return this.subjectProduct.asObservable();
    }

    //Cash
    cashsCol: AngularFirestoreCollection<Cash>;
    cashs: Observable<Cash[]>;
    cashsDoc: AngularFirestoreDocument<Cash>;
    cash: any;
    cashs_array = [];

    getCashs(UID_RESTAURANT) {
        this.cashsCol = this.afs.collection('cashs', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('number', 'desc'));
        this.cashs = this.cashsCol.snapshotChanges().map(actions => {
            return actions.map(a => {
                const data = a.payload.doc.data() as Cash;
                data.UID = a.payload.doc.id;
                return data;
            });
        });


        this.cashsCol.snapshotChanges().subscribe(value => {
            this.cashs_array = [];
            value.map(a => {
                const data = a.payload.doc.data() as Cash;
                data.UID = a.payload.doc.id;
                data._active = true;
                if (this.cashs_array.length >= 1 && !this.globals.checkLimitsByLicense('config', 'multi_cash')) {
                    data._active = false;
                }
                this.cashs_array.push(data);

                return data;
            });

        });

    }

    getCashNumber() {
        this.cashs_array.forEach(value => {
        });


    }

    async cashUpdateNumber(uid, number) {
        //Actualizamos la tabla de la base de datos
        this.afs.collection('cashs').doc(uid).update({
            number: number,
        });
    }

    async getCash(cash_uid) {
        const cashRef = this.firestore.collection('cashs').doc(cash_uid);

        var _cash;

        await
            cashRef.get().then(doc => {
                _cash = doc.data();
                _cash.UID = doc.id;
            });

        return _cash
    }




    //Keyboard
    public keyboard_screen: string = '';

    insertKeyboard(number) {

        if (this.number_units == undefined || this.number_units == null) {
            this.number_units = number;
        } else {
            this.number_units = this.number_units + '' + number;
        }

        if (this.k_screen == undefined || this.k_screen == null || this.k_screen == '') {
            this.keyboard_screen = this.number_units;
        } else {
            this.keyboard_screen = this.number_units + ' x ' + this.k_screen;
        }



    }

    deleteKeyboard() {
        this.keyboard_screen = '';
        this.k_screen = '';
        this.number_units = null;
        this.change_units = true;
    }

    //Help
    cleanDuplicates(arr) {
        var unique = arr.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
        });
        return unique;
    }

    async saveTicketInvoice(pending, payment, payment_type, customer_uid) {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        //Eliminamos el camp variation array para poder hacer el update
        this.cleanTicketArray();
        //get ticket number
        if (this.globals.connection) {
            await this.getTicketNumber(this.globals.restaurant_uid, this.table_tmp.cash_uid);
        } else {
            await this.getTicketNumberOffline();
        }
        //Este while espera que el numero del ticket sea encontrado i superior a 0
        //while (this.ticket_num_return < 0) {}
        this.table_tmp.ticket.amount = this.totalTicketSelected(this.selected_table_tpv_index);
        this.ticket_amount = this.totalTicketSelected(this.selected_table_tpv_index);

        await this.afs.collection('tickets').add({
            UID_RESTAURANT: this.globals.restaurant_uid,
            amount: this.totalTicketSelected(this.selected_table_tpv_index),
            tax: this.globals.RESTAURANT_TAX,
            cash_static: this.table_tmp.cash_static,
            cash_uid: this.table_tmp.cash_uid,
            date: this.table_tmp.ticket.date,
            list: this.table_tmp.ticket.list,
            number: this.ticket_num_return,
            payment: payment,
            payment_type: payment_type,
            waiter: this.table_tmp.ticket.waiter,
            waiter_uid: this.table_tmp.ticket.waiter_uid,
            closed: false,
            pending: pending,
            table_uid: this.table_tmp.UID,
            tip: this.table_tmp.ticket.tip,
            type: this.table_tmp.type,
            customer_uid: customer_uid
        }).then(async doc => {
            this.ticket_uid = await doc.id;
        });
    }

    calculateVariations(units, price, variation_add) {
        if (!variation_add) {
            variation_add = 0;
        }
        return (parseFloat(units) * parseFloat(price)) + parseFloat(variation_add)

    }

    calculateIva(total, subtotal, ticket) {
        if (ticket.tip) {
            total -= ticket.tip;
        }
        return parseFloat(total) - parseFloat(subtotal);
    }

    nameLangSelect(lang, dish) {
        switch (lang) {
            case 'es': {
                //statements;
                return dish.name_es

            }
            case 'ca': {
                //statements;
                return dish.name_ca

            }
            case 'en': {
                //statements;
                return dish.name_en

            }
            case 'de': {
                //statements;
                return dish.name_de

            }
            case 'fr': {
                //statements;
                return dish.name_fr

            }
            case 'it': {
                //statements;
                return dish.name_it

            }
            default: {
                //statements;
                return dish.name_es

            }
        }
    }

    nameLangSelectMenuDish(lang, dish) {
        switch (lang) {
            case 'es': {
                //statements;
                return dish.name

            }
            case 'ca': {
                //statements;
                return dish.name_ca

            }
            case 'en': {
                //statements;
                return dish.name_en

            }
            case 'de': {
                //statements;
                return dish.name_de

            }
            case 'fr': {
                //statements;
                return dish.name_fr

            }
            case 'it': {
                //statements;
                return dish.name_it

            }
            default: {
                //statements;
                return dish.name

            }
        }
    }


    nameProductLangSelect(lang, product) {
        switch (lang) {
            case 'es': {
                //statements;
                return product.name

            }
            case 'ca': {
                //statements;
                return product.name_ca

            }
            case 'en': {
                //statements;
                return product.name_en

            }
            case 'de': {
                //statements;
                return product.name_de

            }
            case 'fr': {
                //statements;
                return product.name_fr

            }
            case 'it': {
                //statements;
                return product.name_it

            }
            default: {
                //statements;
                return product.name

            }
        }
    }

    nameMenuLangSelect(lang, menu) {
        switch (lang) {
            case 'es': {
                //statements;
                return menu.title_es

            }
            case 'ca': {
                //statements;
                return menu.title_ca

            }
            case 'en': {
                //statements;
                return menu.title_en

            }
            case 'de': {
                //statements;
                return menu.title_de

            }
            case 'fr': {
                //statements;
                return menu.title_fr

            }
            case 'it': {
                //statements;
                return menu.title_it

            }
            default: {
                //statements;
                return menu.title_es

            }
        }
    }

    checkTip(quantity) {
        var tip_amount = 0;
        if (quantity) {
            tip_amount = quantity;
        }
        return tip_amount;
    }

    calculateTip(tip_number, total) {
        var tip = 0;

        if (tip_number === 1) {
            tip = (total * this.globals.restaurant.tip_1) / 100;
        } else if (tip_number === 2) {
            tip = (total * this.globals.restaurant.tip_2) / 100;
        } else {
            tip = (total * this.globals.restaurant.tip_3) / 100;
        }

        return tip;
    }


    autoScrollEnterElements() {
        var scroll = document.getElementById("tpv-list-elements");
        scroll.scrollTop = scroll.scrollHeight;
    }

    async getTicketNumberOffline() {
        this.table_tmp = this.tables_array[this.selected_table_tpv_index]; //Iniciamos table tmp para tener una muestra de la tabla seleccionada
        await this.cleanTicketArray();

        var _ticket_num_return = -1;
        //this.ticket_num_return = -1;//Reiniciamos el numero para encontrar el nuevo
        if (!this.table_tmp.ticket.number) {//Comprovamos si el ticket ya tiene un numero para no darle uno de nuevo
            //getitem
            this.nativeStorage.getItem('offline_number')
                .then(
                    data => {
                        _ticket_num_return = Number(data) + 1;
                        this.ticket_num_return = 'off-' + _ticket_num_return;
                        this.tables_array[this.selected_table_tpv_index].ticket.number = 'off-' + _ticket_num_return;
                        //setitem
                        this.nativeStorage.setItem('offline_number', _ticket_num_return)
                            .then(
                                async () => {
                                    await this.updateTableNumber('off-' + _ticket_num_return);
                                },
                                error => { }
                            );
                    },
                    error => { }
                );

        } else {
            this.ticket_num_return = this.table_tmp.ticket.number;
        }
        return true;
    }

    async getIfRoom() {
        if (this.tables_array[this.selected_table_tpv_index].room == undefined) {
            //get room
            var room = await this.configurationServices.getRoom(this.tables_array[this.selected_table_tpv_index].uid_room);
            //update
            this.configurationServices.afs.collection('tables').doc(this.tables_array[this.selected_table_tpv_index].UID).update({
                room: room.name,
            });
        }
    }

    checkIfTablePaid() {
        //
        if (this.selected_table_tpv_index != undefined) {
            //
            if (this.selected_table_tpv_index >= 0 && this.globals.side_menu_active == 'tpv') {
                //
                if (this.tables_array[this.selected_table_tpv_index] != undefined) {
                    //
                    if (this.tables_array[this.selected_table_tpv_index].payment && this.tables_array[this.selected_table_tpv_index].payment_source != '' && !this.globals.table_paid_alert) {
                        //
                        this.globals.launchAlertTablePaid(this.tables_array[this.selected_table_tpv_index], 'tpv');
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/tpv/services.ts